import React from 'react'
import SharedNotesModal from './SharedNotesModal'

const ModalNotes = ({closeModal, clientInfo}) => {
    const clientName = `${clientInfo?.first_name ?? ''} ${clientInfo?.last_name ?? ''}`.trim();

    return (
        <SharedNotesModal
            closeModal={closeModal}
            entityInfo={clientInfo}
            title={`${clientName}: Client Notes`}
            fetchPath='/client_notes/client/'
            createPath='/client_notes/'
            createEntityKey='client'
        />
    )
}

export default ModalNotes